import * as React from 'react';
import Svg, {SvgProps, Path} from 'react-native-svg';
const SvgComponent = (props: SvgProps) => (
  <Svg
    width={17}
    height={19}
    viewBox={'0 0 17 19'}
    {...props}
    fill="none"
    stroke="none">
    <Path
      fill={props.fill || '#9D9EC5'}
      d="M14.47 7.72h-1.23V5.26c0-2.72-2.2-4.92-4.92-4.92C5.6.34 3.4 2.54 3.4 5.26v2.46H2.17c-1.02 0-1.85.83-1.85 1.85v7.38c0 1.02.83 1.85 1.85 1.85h12.31c1.02 0 1.85-.83 1.85-1.85V9.57c0-1.02-.83-1.85-1.85-1.85h-.01ZM4.62 5.26c0-2.04 1.65-3.69 3.69-3.69S12 3.22 12 5.26v2.46H4.62V5.26Zm10.46 11.69c0 .34-.28.62-.62.62H2.15c-.34 0-.62-.28-.62-.62V9.57c0-.34.28-.62.62-.62h12.31c.34 0 .62.28.62.62v7.38Zm-6.15-4.92v2.46c0 .34-.28.62-.62.62-.34 0-.62-.28-.62-.62v-2.46c0-.34.28-.62.62-.62.34 0 .62.28.62.62Z"
    />
  </Svg>
);
export default SvgComponent;
